import { render, staticRenderFns } from "./GalleryManager.vue?vue&type=template&id=6df2c6d2&"
import script from "./GalleryManager.vue?vue&type=script&lang=js&"
export * from "./GalleryManager.vue?vue&type=script&lang=js&"
import style0 from "./GalleryManager.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports